//
//
//
//
//
//
//
//
//
//

import { mdiFileFindOutline } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiFileFindOutline,
      },
    }
  },
}
